module.exports = __webpack_public_path__ + "media/dashboard/assets/images/export-ce11a4727f04ed8d899791f737ef663e.svg";